import React from 'react';
import { Row, Col, Form, Button, Badge } from 'react-bootstrap';
import { shouldUseDropdown, shouldSendTextValue, shouldUseClientModal, getDropdownOptionsForField } from '../utils/analyticsUtils';

const FilterGroup = ({ 
  filterGroups, 
  selectedTableInfo, 
  dropdownOptions,
  clientNames,
  onUpdateFilter, 
  onRemoveFilter, 
  onUpdateGroupLogicalOperator,
  onAddFilter,
  onOpenClientModal,
  onHandleClientIdChange,
  getSelectedClientName,
  getFilterColumnInfo
}) => {
  return (
    <>
      {filterGroups.map((group, groupIndex) => (
        <div key={groupIndex}>
          {groupIndex > 0 && (
            <div className="text-center mb-2">
              <Form.Select
                value={group.logicalOperator || 0}
                onChange={(e) => onUpdateGroupLogicalOperator(groupIndex, parseInt(e.target.value))}
                style={{ width: '120px', margin: '0 auto' }}
                size="sm"
              >
                <option value={0}>Y (AND)</option>
                <option value={1}>O (OR)</option>
              </Form.Select>
            </div>
          )}
          <div className={`mb-3 ${groupIndex > 0 ? 'border border-info rounded p-3' : ''}`}>
            {groupIndex > 0 && (
              <div className="d-flex justify-content-between align-items-center mb-2">
                <Badge bg="info">Grupo {groupIndex}</Badge>
              </div>
            )}
            {group.filters.map((filter, filterIndex) => (
              <div key={filterIndex} className="border p-3 mb-2 rounded">
                {filterIndex > 0 && (
                  <Row className="mb-2">
                    <Col>
                      <Form.Select
                        value={filter.logicalOperator || 0}
                        onChange={(e) => onUpdateFilter(groupIndex, filterIndex, 'logicalOperator', parseInt(e.target.value))}
                        size="sm"
                      >
                        <option value={0}>Y (AND)</option>
                        <option value={1}>O (OR)</option>
                      </Form.Select>
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col>
                    <Form.Select
                      value={filter.fieldName}
                      onChange={(e) => onUpdateFilter(groupIndex, filterIndex, 'fieldName', e.target.value)}
                    >
                      <option value="">Seleccionar campo...</option>
                      {(selectedTableInfo?.columns?.filters || []).map(column => (
                        <option key={column.name} value={column.name}>
                          {column.displayName || column.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col>
                    <Form.Select
                      value={filter.operator}
                      onChange={(e) => onUpdateFilter(groupIndex, filterIndex, 'operator', parseInt(e.target.value))}
                    >
                      <option value={0}>Igual</option>
                      <option value={1}>No Igual</option>
                      <option value={2}>Mayor que</option>
                      <option value={3}>Menor que</option>
                      {!filter.fieldName.endsWith('Id') && (
                        <>
                          <option value={4}>Contiene</option>
                          <option value={5}>No Contiene</option>
                          <option value={6}>Empieza por</option>
                          <option value={7}>Termina por</option>
                        </>
                      )}
                      <option value={8}>Tiene Valor</option>
                      <option value={9}>No Tiene Valor</option>
                    </Form.Select>
                  </Col>
                  <Col>
                    <FilterValueInput
                      filter={filter}
                      groupIndex={groupIndex}
                      filterIndex={filterIndex}
                      getFilterColumnInfo={getFilterColumnInfo}
                      shouldUseClientModal={shouldUseClientModal}
                      shouldUseDropdown={shouldUseDropdown}
                      shouldSendTextValue={shouldSendTextValue}
                      dropdownOptions={dropdownOptions}
                      clientNames={clientNames}
                      onUpdateFilter={onUpdateFilter}
                      onOpenClientModal={onOpenClientModal}
                      onHandleClientIdChange={onHandleClientIdChange}
                      getSelectedClientName={getSelectedClientName}
                      getDropdownOptionsForField={getDropdownOptionsForField}
                    />
                  </Col>
                  <Col xs="auto">
                    <Button 
                      variant="outline-danger" 
                      size="sm"
                      onClick={() => onRemoveFilter(groupIndex, filterIndex)}
                    >
                      ×
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <div className="text-center mt-2">
              <Button 
                variant="outline-primary" 
                size="sm" 
                onClick={() => onAddFilter(groupIndex)}
              >
                + Añadir Filtro
              </Button>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

const FilterValueInput = ({ 
  filter, 
  groupIndex, 
  filterIndex, 
  getFilterColumnInfo,
  shouldUseClientModal,
  shouldUseDropdown,
  shouldSendTextValue,
  dropdownOptions,
  clientNames,
  onUpdateFilter,
  onOpenClientModal,
  onHandleClientIdChange,
  getSelectedClientName,
  getDropdownOptionsForField
}) => {
  const columnInfo = getFilterColumnInfo(filter.fieldName);
  const isDisabled = filter.operator === 8 || filter.operator === 9;
  
  if (columnInfo?.type === 'bool') {
    return (
      <Form.Select
        value={filter.value}
        onChange={(e) => onUpdateFilter(groupIndex, filterIndex, 'value', e.target.value)}
        disabled={isDisabled}
      >
        <option value="">Seleccionar valor...</option>
        <option value="true">Verdadero</option>
        <option value="false">Falso</option>
      </Form.Select>
    );
  }
  
  if (columnInfo?.type === 'datetime') {
    return (
      <Form.Control
        type="datetime-local"
        value={filter.value}
        onChange={(e) => onUpdateFilter(groupIndex, filterIndex, 'value', e.target.value)}
        disabled={isDisabled}
      />
    );
  }
  
  if (shouldUseClientModal(filter.fieldName)) {
    return (
      <div>
        <div className="d-flex mb-1">
          <Form.Control
            type="number"
            placeholder="ID del cliente"
            value={filter.value}
            onChange={(e) => onHandleClientIdChange(groupIndex, filterIndex, e.target.value)}
            disabled={isDisabled}
          />
          <Button
            variant="outline-primary"
            onClick={() => onOpenClientModal(groupIndex, filterIndex)}
            disabled={isDisabled}
            className="ms-2"
          >
            Buscar
          </Button>
          {filter.value && (
            <Button
              variant="outline-danger"
              onClick={() => onUpdateFilter(groupIndex, filterIndex, 'value', '')}
              disabled={isDisabled}
              className="ms-1"
            >
              ×
            </Button>
          )}
        </div>
        {filter.value && (
          <small className="text-muted">{getSelectedClientName(filter.value)}</small>
        )}
      </div>
    );
  }
  
  if (shouldUseDropdown(filter.fieldName, dropdownOptions) && ![4, 5, 6, 7].includes(filter.operator)) {
    const options = getDropdownOptionsForField(filter.fieldName, dropdownOptions);
    return (
      <Form.Select
        value={filter.value}
        onChange={(e) => onUpdateFilter(groupIndex, filterIndex, 'value', e.target.value)}
        disabled={isDisabled}
      >
        <option value="">Seleccionar...</option>
        {options.map(option => {
          const id = option.valueId || option.id || option.value;
          const name = option.categoryName || option.typeName || option.modelName || option.colorName || option.size || option.name || option.displayName || option.label || option.text || `${option.firstName} ${option.lastName1}`.trim() || option.abrev || id;
          const value = shouldSendTextValue(filter.fieldName) ? name : id;
          return (
            <option key={id} value={value}>
              {name}
            </option>
          );
        })}
      </Form.Select>
    );
  }
  
  if (['int', 'decimal', 'double'].includes(columnInfo?.type)) {
    return (
      <Form.Control
        type="number"
        step={columnInfo.type === 'int' ? '1' : '0.01'}
        placeholder="Valor numérico"
        value={filter.value}
        onChange={(e) => onUpdateFilter(groupIndex, filterIndex, 'value', e.target.value)}
        disabled={isDisabled}
      />
    );
  }
  
  return (
    <Form.Control
      type="text"
      placeholder="Valor"
      value={filter.value}
      onChange={(e) => onUpdateFilter(groupIndex, filterIndex, 'value', e.target.value)}
      disabled={isDisabled}
    />
  );
};

export default FilterGroup;